import aos from 'aos';
import { CountUp } from 'countup.js';
import ProgressBar from 'progressbar.js';

// only bother with this code if homepage stats componet is present
if (document.querySelector('.homepage-stats__section')) {
    // COUNT UP ANIMATIONS
    const numOneOptions = {
        duration: 2
    };
    const numOneEl = document.querySelector('.countup-1');
    const numOneValue = numOneEl.getAttribute('data-number');
    const numOneAnimation = new CountUp(numOneEl, numOneValue, numOneOptions);

    const numTwoOptions = {
        duration: 4
    };
    const numTwoEl = document.querySelector('.countup-2');
    const numTwoValue = numTwoEl.getAttribute('data-number');
    const numTwoAnimation = new CountUp(numTwoEl, numTwoValue, numTwoOptions);

    const numThreeOptions = {
        duration: 3
    };
    const numThreeEl = document.querySelector('.countup-3');
    const numThreeValue = numThreeEl.getAttribute('data-number');
    const numThreeAnimation = new CountUp(numThreeEl, numThreeValue, numThreeOptions);

    const numFourOptions = {
        duration: 3
    };
    const numFourEl = document.querySelector('.countup-4');
    const numFourValue = numFourEl.getAttribute('data-number');
    const numFourAnimation = new CountUp(numFourEl, numFourValue, numFourOptions);

    // CIRCLE ANIMATIONS
    const circleOneEl = document.querySelector('.homepage-stats__circle--one');
    const circleOne = new ProgressBar.Circle(circleOneEl, {
        strokeWidth: 13,
        easing: 'easeInOut',
        duration: 1400,
        color: '#0145E9',
        trailColor: '#E3E3E3',
        trailWidth: 13,
        svgStyle: null
    });

    const circleTwoEl = document.querySelector('.homepage-stats__circle--two');
    const circleTwo = new ProgressBar.Circle(circleTwoEl, {
        strokeWidth: 13,
        easing: 'easeInOut',
        duration: 1400,
        color: '#16D0AC',
        trailColor: '#E3E3E3',
        trailWidth: 13,
        svgStyle: null
    });

    const circleThreeEl = document.querySelector('.homepage-stats__circle--three');
    const circleThree = new ProgressBar.Circle(circleThreeEl, {
        strokeWidth: 18,
        easing: 'easeInOut',
        duration: 1400,
        color: '#8AC6D6',
        trailColor: '#E3E3E3',
        trailWidth: 13,
        svgStyle: null
    });

    const circleThreeBEl = document.querySelector('.homepage-stats__circle--three-b');
    const circleThreeB = new ProgressBar.Circle(circleThreeBEl, {
        strokeWidth: 13,
        easing: 'easeInOut',
        duration: 1400,
        color: '#ECE176',
        trailColor: 'rgba(255, 0, 0, 0)',
        trailWidth: 13,
        svgStyle: null
    });

    const circleFourEl = document.querySelector('.homepage-stats__circle--four');
    const circleFour = new ProgressBar.Circle(circleFourEl, {
        strokeWidth: 13,
        easing: 'easeInOut',
        duration: 1400,
        color: '#ECE176',
        trailColor: '#E3E3E3',
        trailWidth: 13,
        svgStyle: null
    });

    const circleTwoAnimValue = numTwoValue / 100;
    const circleThreeAnimValue = numThreeValue * 0.25;

    let animOneTriggered, animTwoTriggered, animThreeTriggered, animFourTriggered;

    document.addEventListener('aos:in:circle-one', () => {
        if (animOneTriggered !== true) {
            setTimeout(() => {
                numOneAnimation.start();
                circleOne.animate(1.0);
                animOneTriggered = true;
            }, 100);
        }
    });
    document.addEventListener('aos:in:circle-two', () => {
        if (animTwoTriggered !== true) {
            setTimeout(() => {
                numTwoAnimation.start();
                circleTwo.animate(circleTwoAnimValue);
                animTwoTriggered = true;
            }, 100);
        }
    });
    document.addEventListener('aos:in:circle-three', () => {
        if (animThreeTriggered !== true) {
            setTimeout(() => {
                numThreeAnimation.start();
                circleThree.animate(circleThreeAnimValue);
                circleThreeB.animate(0.25);
                animThreeTriggered = true;
            }, 100);
        }
    });
    document.addEventListener('aos:in:circle-four', () => {
        if (animFourTriggered !== true) {
            setTimeout(() => {
                numFourAnimation.start();
                circleFour.animate(1.0);
                animFourTriggered = true;
            }, 100);
        }
    });
}
